
import {
	Component,
	Vue,
	Watch
} from 'vue-property-decorator';
import RadioButton from '@/components/radio-button.vue';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import Message from '@/components/message.vue';
import Dialog from '@/components/dialog.vue';
import fillinlogistics from './components/fillinlogistics.vue';
import fillSendBack from './components/fillSendBack.vue';
import {
	afterSalesTypes,
	afterStatus,
	afterSalesResults
} from '@/utils/config'
import {
	orderSupportlist,
	checkOrderRefund,
	confirmReceiveGoods,
	orderSupportrefund,
	orderSupportclose,
	memberdirectCompanyMemberList,
	employeeResponsibleTeamlist,
	employeeResponsibleTeamsave,
	orderSupportdetail,
	orderSupportinsteadCustomerConfirmReceiveGoods,
	orderSupportemployeelist,
	orderSupportoverview,
	orderSupportreturnCheck,
	specialDealcouponInfoList,
	specialDealinvalidCoupon
} from '@/api/after_sales'
import {
	getSearchDate,
	nextDay
} from "@/utils/index"

import {
	lookExpress
} from '@/api/order'
import {
	handleClipboard
} from '@/utils/clipboard'
import {
	UserModule
} from "@/store/modules/user"
import {
	providerSelectItem
} from '@/api/supplier';

import {
	getExpressList,
} from '@/api/logistics';
import searchOrderDialog from "@/components/searchOrderDialog.vue"
import changeRemark from "@/views/aftersales/components/changeRemark.vue"
@Component({
	name: 'aftersales-order',
	components: {
		RadioButton,
		PageFooter,
		PickerDate,
		'slz-message': Message,
		'slz-dialog': Dialog,
		fillinlogistics,
		fillSendBack,
		searchOrderDialog,
		changeRemark
	}
})
export default class AftersalesOrder extends Vue {
	private defaultThumb = 'https://cdn2024.routuan.com/routuanapp/default-thumb.png';
	private shopname = ''
	private keyword = '';
	private namephone = '';
	private salestype = 4;
	private salestypelist: any = [
		// {value:null,label:'全部'},
		{ value: 4, label: '未发货仅退款' },
		{ value: 3, label: '仅退款' },
		{ value: 1, label: '换货' },
		{ value: 2, label: '退货退款' },
		{ value: 5, label: '破损补寄' },
	];
	private state = null;
	private statelist: any = [];
	private allstatelist: any = [
		{ value: null, label: '全部', type: [null, 1, 2, 3, 4, 5] },
		{ value: 0, label: '待审核', type: [1, 2, 3, 4, 5], },
		{ value: 10, label: '已驳回', type: [1, 2, 3, 4, 5], },
		{ value: 20, label: '待买家退回', type: [1, 2], },
		{ value: 30, label: '买家已寄回', type: [1, 2], },
		{ value: 35, label: '已确认收货退款中', type: [2], },
		{ value: 35, label: '审核通过退款中', type: [3, 4], },
		{ value: 36, label: '退款失败', type: [1, 2, 3, 4], },
		{ value: 40, label: '待商家寄出', type: [1, 5] },
		{ value: 50, label: '待买家确认收货', type: [1, 5] },
		{ value: 60, label: '已完结', type: [1, 2, 3, 4, 5], },
		{ value: 70, label: '已关闭', type: [1, 2, 3, 4, 5], },
	];
	private check = null
	private checklist: any = []
	private filterTime: any = [getSearchDate(2, false, -29)[0], getSearchDate(2)[0]].join('/');
	private completedTime: any = ''
	private filterTime2: any = ''
	private result: any = {}

	private list: any = [];
	private selectType = 0
	private tableloading = false

	private pageNo = 1;
	private pageSize = 10;
	private total = 0;

	private afterSalesTypes = afterSalesTypes;
	private afterSalesStatus = afterStatus;
	private afterSalesResults = afterSalesResults;
	private select: any = [{
		label: '提交时间',
		value: 0
	}]
	private selectNum: any = [{
		label: '下单编号',
		value: 0
	}]
	private currentId = 0;
	private showMessage = false;
	private showConfirmMessage = false;

	private rowmsg: any = {}
	private takeGoodsShow = false

	private fillinShow = false
	private SupportNo = ''

	private refundagainShow = false
	private refundagainloading = false
	private refundmsg: any = {
		title: '',
		content: '',
		Show: false,
		type: 'warn',
		showicon: true
	}
	private salesShow = false
	private salesresson = ''

	private searchkeywords = ''
	private teamlist: any = []
	private allteam: any = []

	private orderdetail: any = {}

	private logisticsdata: any = {}
	private logisticsmsg: any = []
	private logisticsshow = false
	private lookloading = false

	private lastpageType = 2
	private receiveShow = false
	private receivemsg: any = {
		show: false,
		message: '',
		content: '',
	}
	private isunfold = false
	private conditionloading = false
	private conditionlist: any = []
	private ReturnFreightInsuranceResponsibleParty = null
	private assemblyRefundShow = false
	private ProductMixRefundRate = 100
	private supplier = null
	private supplierlist: any = []

	private sendBackShow = false
	private sendBackMsg: any = {}
	private searchOrderShow = false
	private bannerColor = {
		0: '#f92519',
		1: '#ef8733',
		2: '#2e63f6',
		3: '#1cac34',
		4: '#873df1',
	}
	private remarkShow = false

	private guo: any = {
		show: false,
		keywords: '',
		list: [],
		loading: false,
		confirmPop: false
	}


	private mounted() {
		this.salestypechange(this.salestype, true)
	}


	activated() {
		this.getSupplierList()
		this.getchecklist()
		this.getchargeteamlist()
		this.getallteamlist()
		this.getcondition()
		this.getList()
	}


	private handleShowGuo() {
		this.guo.keywords = '';
		this.guo.list = [];
		this.guo.show = true;
	}
	private async guoGetList(){
		this.guo.loading = true;
		try {
			let res: any = await specialDealcouponInfoList({ChildOrderNo: this.guo.keywords});
			this.guo.list = res.Result;
		} catch (e) {
			console.error(e)
		} finally {
			this.guo.loading = false;
		}
	}
	private guoSureSubmit(){
		if (!this.guo.list.length){
			this.$message.error('请先查询');
			return;
		}
		this.guo.confirmPop = true;
	}
	private async guoSubmit(){
		

		try {
			let res: any = await specialDealinvalidCoupon({ChildOrderNo: this.guo.keywords});
			this.$message.success('操作成功');
			this.guo.confirmPop = false;
			this.guo.show = false;
		} catch (e) {
			console.error(e)
		} finally {
		}
	}

	private toChangeRemark(row) {
		this.rowmsg = JSON.parse(JSON.stringify(row))
		this.remarkShow = true
	}
	private fillSendBack(row) {
		if (row.ReturnWay == 2) {
			this.$message.error('该售后单已经申请上门取件，不支持帮助填写物流！')
			return
		}
		this.SupportNo = row.SupportNo
		this.sendBackShow = true
	}
	toRemind(type) {
		this.$router.push({
			path: 'remindReceive',
			query: {
				Type: type
			}
		})
	}
	// 获取供应商列表
	private async getSupplierList() {
		try {
			const res: any = await providerSelectItem({});
			this.supplierlist = res.Result.map(v => {
				return {
					value: v.Id,
					label: v.ProviderName
				}
			})
		} catch (e) {
			console.log('supplierList ===>', e);
		}
	}
	private confirmassemblyRefund() {
		let two = /^\d+(\.\d{1,2})?$/
		if (!this.ProductMixRefundRate) {
			this.$message.error('请输入退款比例')
			return
		}
		if (this.ProductMixRefundRate < 0.01 || this.ProductMixRefundRate > 100 || !two.test(String(this.ProductMixRefundRate))) {
			this.$message.error('请输入0.01~100以内的退款比例')
			return
		}
		this.realTake()
	}
	private async backwaitreviewed(row) {

		try {

			let res = await orderSupportreturnCheck({
				SupportNo: row.SupportNo
			})
			if (res.IsSuccess) {
				this.$message('操作成功')
				this.getList()
			}
		} finally {
			//
		}
	}
	private async getcondition() {
		try {
			this.conditionloading = true
			let res = await orderSupportoverview({})
			if (res.IsSuccess) {
				// console.log(res.Result)
				let rgblist = ['rgb(243,149,0)', 'rgb(119,42,145)', 'rgb(0,153,224)', 'rgb(253,117,42)', 'rgb(0,17,173)']
				this.conditionlist = res.Result.map((v, i) => {
					v.rgb = rgblist[i]
					return v
				})
			}
		} finally {
			this.conditionloading = false
		}
	}
	private async getchecklist() {
		try {
			let res = await orderSupportemployeelist({})
			if (res.IsSuccess) {
				this.checklist = [{ Id: null, EmployeeName: '全部' }, ...res.Result].map(v => {
					return {
						value: v.Id,
						label: v.EmployeeName
					}
				})
			}
		} finally {
			//
		}
	}
	private async toeeceive() {
		try {
			let res = await orderSupportinsteadCustomerConfirmReceiveGoods({
				SupportNo: this.rowmsg.SupportNo,
			})
			if (res.IsSuccess) {
				this.receiveShow = false
				this.receivemsg = {
					show: true,
					message: res.Message,
					content: res.Result.MessageContent,
				}
				this.getList()
			}
		} finally {
			//
		}
	}
	private receivegoods(row) {
		this.rowmsg = row
		this.receiveShow = true
	}
	private looklogistics(row) {
		this.logisticsshow = true
		this.logisticsdata = {
			ExpressValue: row.ReturnExpressValue,
			ExpressNo: row.ReturnExpressNo,
			address: row.ReturnReceiveProvince + row.ReturnReceiveCity + row.ReturnReceiveArea + row.ReturnReceiveAddress,
		}
		let data = {
			ExpressId: row.ReturnExpressId,
			ExpressNo: row.ReturnExpressNo,
			ReceivePhone: row.ReturnReceivePhone,
		}
		this.getlogistics(data)
	}
	private async getlogistics(data) {
		try {
			this.lookloading = true
			this.logisticsmsg = []
			let res = await lookExpress(await data)
			if (res.IsSuccess) {
				this.logisticsmsg = res.Result.sort((a, b) => {
					return -1
				}).map((item, index) => {
					item.color = index === 0 ? '#0067cc' : '#999';
					return item;
				})
			}
		} finally {
			this.lookloading = false
		}
	}
	private async getorderdetail(row) {
		// console.log(row)
		let res = await orderSupportdetail({
			SupportNo: await row.SupportNo
		})
		if (res.IsSuccess) {
			this.orderdetail = res.Result
			return true
		}
	}
	private async tocopy(row) {
		try {
			await this.getorderdetail(row);
			this.$nextTick(() => {
				setTimeout(() => {
					let copy = document.getElementById('copy') as any
					copy.click()
				}, 0);
			})
		} finally {
			//
		}
	}
	private copyaftersales(event) {
		let text = ''
		text += '★订单编号：' + this.orderdetail.OrderNoDisplay + '\n'
		text += '★售后编号：' + this.orderdetail.SupportNo + ';' + this.orderdetail.SupportTypeValue + '\n'
		text += '★申请人：' + this.orderdetail.CustomerName + '  ' + this.orderdetail.CustomerPhone + '\n'
		text += '★订单审核序列：' + this.orderdetail.CheckSequence + '\n'
		text += '★商品名称：' + this.orderdetail.ProductName + '\n'
		text += '★发货单号：' + this.orderdetail.OrderDetailExpressInfo
		text += '\n'

		text += '★寄回单号：' + this.orderdetail.ReturnExpressValue + '' + this.orderdetail.ReturnExpressNo + '\n'
		text += '★下单时间：' + this.orderdetail.OrderAddTime + '\n'
		text += '★订单信息：' + this.orderdetail.ReceiveName + '。' + this.orderdetail.ReceivePhone + '。' + this.orderdetail.ReceiveProvince +
			this.orderdetail.ReceiveCity + this.orderdetail.ReceiveArea + this.orderdetail.ReceiveAddress + '。' + '\n' +
			this.orderdetail.ProductName + '。' + this.orderdetail.OriginalSpecValueDisplay + 'x' + this.orderdetail.ProductCount + '\n'
		text += '★售后原因：' + this.orderdetail.SupportReason + '\n'
		text += '★补充描述：' + this.orderdetail.CustomerRemark + '\n'
		if (this.orderdetail.SupportType == 1) {
			text += '★换后规格：' + this.orderdetail.ProductName + '。' + this.orderdetail.NewSpecValueDisplay + 'x' + this.orderdetail.ProductCount + '\n'
		}
		text += '★解决方案：'
		handleClipboard(text, event)
	}
	private closetag(e) {
		this.teamlist.splice(e, 1)
	}
	private async getallteamlist() {
		try {
			let res = await memberdirectCompanyMemberList({})
			if (res.IsSuccess) {
				this.allteam = res.Result
			}
		} finally {
			//
		}
	}
	private async getchargeteamlist() {
		try {
			let res = await employeeResponsibleTeamlist({})
			if (res.IsSuccess) {
				// console.log(res)
				this.teamlist = res.Result.map(v => {
					v.Id = v.MemberId
					return v
				})
				// console.log(this.teamlist,123)
			}
		} finally {
			//
		}
	}
	private async saveteam() {
		try {
			let data = {
				MemberIdList: this.teamlist.map(v => v.Id)
			}
			// console.log(data)
			let res = await employeeResponsibleTeamsave(data)
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.getchargeteamlist()
				this.getchargeteamlist()
			}
		} finally {
			//
		}
	}
	private joinmyteam() {
		if (!this.searchkeywords) {
			this.$message.error('请输入姓名')
			return
		} else if (this.teamlist.find(v => { return v.Id == this.searchkeywords })?.Id) {
			this.$message.error('已负责该团队，请勿重新添加')
			return
		}
		this.teamlist.push(this.allteam.find(v => { return v.Id == this.searchkeywords }))
		this.searchkeywords = ''
	}

	private async applyforclose() {
		if (!this.salesresson) {
			this.$message.error('请输入关闭售后单原因')
			return
		}
		try {
			let res = await orderSupportclose({
				SupportNo: this.rowmsg.SupportNo,
				CloseReason: this.salesresson
			})
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.salesShow = false
				this.getList()
			}
		} finally {
			//
		}
	}

	private closesales(row) {
		this.rowmsg = row
		this.salesresson = ''
		this.salesShow = true
	}
	private showtops() {
		this.refundmsg = {
			title: '售后数量',
			content: '本次售后数量/原始订单购买商品数量',
			Show: true,
			type: 'notice',
			showicon: true
		}
	}
	private salestypechange(e, isinit?: boolean) {
		// console.log(e)
		this.statelist = this.allstatelist.filter(v => {
			return v.type.includes(e)
		})
		this.state = this.statelist[0].value
		if (!isinit) {
			this.doSearch()
		}
	}
	private async confirmrefundagain() {
		try {
			this.refundagainloading = true
			let data: any = {
				SupportNo: this.rowmsg.SupportNo,
				IsModifyRemark: false,
				SystemRemark: '',
				noError: true
			}
			let res = await orderSupportrefund(data)
			if (res.IsSuccess) {
				this.refundagainShow = false
				this.refundmsg = {
					title: '退款成功',
					content: res.Message,
					Show: true,
					type: 'success',
					showicon: true
				}
				this.getList()
			} else {
				let res2 = await orderSupportdetail({
					SupportNo: this.rowmsg.SupportNo
				})
				let detailmsg = res2.Result
				this.refundmsg = {
					title: '退款失败',
					content: res.Message,
					Show: true,
					type: 'warn',
					showicon: true,
					RefundState: detailmsg.RefundState,
					ReturnFreightInsuranceState: detailmsg.ReturnFreightInsuranceState,
				}
			}
		} catch (err) {
			this.refundagainShow = false
		} finally {
			this.refundagainShow = false
			this.refundagainloading = false
		}
	}
	private refundagain(row) {
		this.rowmsg = row
		this.refundagainShow = true
	}
	private exportlist() {
		if (this.checktime()) return
		var url = location.origin + '/pc/orderSupport/list' +
			'?Keywords=' + (this.keyword ? this.keyword : '') +
			'&ProductName=' + (this.shopname ? this.shopname : '') +
			'&CustomerInfo=' + (this.namephone ? this.namephone : '') +
			'&SupportType=' + (this.salestype ? this.salestype : '') +
			'&SupportState=' + (this.state ? this.state : '') +
			'&CheckEmployeeId=' + (this.check || '') +
			'&ProviderId=' + (this.supplier == null ? '' : this.supplier)

		if (this.filterTime) {
			var dt = this.filterTime.split('/');
			url += '&StartTime=' + dt[0];
			url += '&EndTime=' + nextDay(dt[1], 1);
		}
		if (this.completedTime) {
			var ct = this.completedTime.split('/');
			url += '&CompleteStartTime=' + ct[0];
			url += '&CompleteEndTime=' + nextDay(ct[1], 1);
		}
		if (this.filterTime2) {
			var dt2 = this.filterTime2.split('/');
			url += '&OriginalOrderAddStartTime=' + dt2[0];
			url += '&OriginalOrderAddEndTime=' + nextDay(dt2[1], 1);
		}
		window.open(url)
	}
	private checktime() {
		if (this.completedTime && !this.filterTime) {
			this.$message.error('请同步选择售后单提交时间')
			return true
		}
		return false
	}

	private async realTake() {
		try {
			let res = await confirmReceiveGoods({
				SupportNo: this.rowmsg.SupportNo,
				ReturnFreightInsuranceResponsibleParty: this.ReturnFreightInsuranceResponsibleParty,
				ProductMixRefundRate: this.ProductMixRefundRate / 100
			})
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.takeGoodsShow = false
			}
		} finally {
			this.takeGoodsShow = false
			this.assemblyRefundShow = false
		}
	}
	private async confirmtakeGoods() {
		if ((this.rowmsg.SupportType == 1 || this.rowmsg.SupportType == 2) && this.rowmsg.SupportState == 30 && this.ReturnFreightInsuranceResponsibleParty == null
			&& this.rowmsg.ReturnFreightInsuranceMoney > 0) {
			this.$message.error('请选择本次售后的运费承担方！')
			return
		}
		if (this.rowmsg.SupportType == 2 && this.rowmsg.ProductType == 1) {
			this.takeGoodsShow = false
			this.assemblyRefundShow = true
			this.ProductMixRefundRate = 100
		} else {
			this.realTake()
		}
	}

	private todetail(row, type) {
		this.lastpageType = type
		this.$router.push({
			path: '/aftersales/detail',
			query: {
				SupportNo: row.SupportNo
			}
		})
	}
	private handleToFreightCompensationStatistical() {
		this.$router.push({
			name: 'freightCompensationStatistical',
			query: {}
		})
	}

	private tofillin(row) {
		this.rowmsg = row
		this.SupportNo = row.SupportNo
		this.fillinShow = true
	}

	private takeGoods(row) {
		this.rowmsg = row
		if ((this.rowmsg.SupportType == 1 || this.rowmsg.SupportType == 2)
			&& this.rowmsg.SupportState == 30 && this.rowmsg.ReturnFreightInsuranceMoney > 0) {
			this.takeGoodsShow = true
			this.ReturnFreightInsuranceResponsibleParty = null
		} else if (this.rowmsg.SupportType == 2 && this.rowmsg.ProductType == 1) {
			this.assemblyRefundShow = true
			this.ProductMixRefundRate = 100
		} else {
			this.takeGoodsShow = true
		}
	}

	// private toDetail(id: number) {
	//   this.$router.push({
	//     name: 'After_Detail',
	//     query: {
	//       id: id + ''
	//     }
	//   })
	// }

	private doSearch() {
		if (this.checktime()) return
		if (!this.filterTime && !this.completedTime && !this.filterTime2) {
			this.$message.error('请选择时间')
			return
		}
		for (let item of [this.filterTime, this.completedTime, this.filterTime2]) {
			if (item) {
				var dt = item.split('/')
				let StartTime = dt[0]
				let EndTime = dt[1]
				let time = (new Date(EndTime).getTime() - new Date(StartTime).getTime()) / 1000 / 60 / 60 / 24
				if (time > 179) {
					this.$message.error('跨度不允许超过180天')
					return
				}
			}
		}

		this.pageNo = 1;
		this.getList()
	}

	private clearSearch() {
		this.shopname = ''
		this.keyword = ''
		this.namephone = ''
		this.supplier = null
		// this.salestype = 1
		// this.state = null
		this.salestypechange(this.salestype, true)
		this.filterTime = [getSearchDate(2, false, -29)[0], getSearchDate(2)[0]].join('/')
		this.completedTime = ''
		this.filterTime2 = ''
		this.pageNo = 1;
		this.getList()
	}

	private changePage(num: number) {
		this.pageNo = num;
		this.getList();
	}

	private async getList() {
		let params: any = {
			Keywords: this.keyword,
			ProductName: this.shopname,
			CustomerInfo: this.namephone,
			SupportType: this.salestype,
			SupportState: this.state,
			Skip: (this.pageNo - 1) * this.pageSize,
			Take: this.pageSize,
			CheckEmployeeId: this.check,
			ProviderId: this.supplier
		}
		if (this.filterTime) {
			let time = this.filterTime.split('/');
			params.StartTime = time[0];
			params.EndTime = nextDay(time[1], 1)
		}
		if (this.completedTime) {
			let time = this.completedTime.split('/');
			params.CompleteStartTime = time[0];
			params.CompleteEndTime = nextDay(time[1], 1)
		}
		if (this.filterTime2) {
			let time = this.filterTime2.split('/');
			params.OriginalOrderAddStartTime = time[0];
			params.OriginalOrderAddEndTime = nextDay(time[1], 1)
		}
		try {
			this.tableloading = true
			const res: any = await orderSupportlist(params);
			this.list = res.Result.Results || [];
			this.total = res.Result.Total;
			this.result = res.Result
		} catch (e) {
			console.log(e)
		} finally {
			this.tableloading = false
		}
	}

	private cancelAfterSales(id: number) {
		this.currentId = id;
		this.showMessage = true;
	}

	private confirmRefund(id: number) {
		this.currentId = id;
		this.showConfirmMessage = true;
	}

	private async confirmCancel() {
		try {
			await checkOrderRefund({
				refund_id: this.currentId,
				state: 2
			})
			this.$message({
				type: 'success',
				message: '已取消'
			})
			this.getList();
		} catch (e) {
			console.log(e)
		}
	}

	private async confirmAfterSales() {
		try {
			await checkOrderRefund({
				refund_id: this.currentId,
				state: 1
			})
			this.$message({
				type: 'success',
				message: '已确认'
			})
			this.getList();
		} catch (e) {
			console.log(e)
		}
	}
}
